import { DOWNLOAD_IMPORTER } from './constants'

export function downloadImporter(contentId) {
    return {
        type: DOWNLOAD_IMPORTER,
        data: {
            contentId,
        },
    }
}
